import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ScreenService } from '../../../services/screen.service';
import { HhsgSharedUserProfile } from '../../../models';
import { HhsgSharedConfigService, HhsgSharedLoadingService, HhsgSharedUserService } from '../../../services';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {SideNavItemModel} from "../../../material-design";

@Component({
  selector: 'huron-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class HhsgLayoutComponent implements OnInit, OnDestroy {
	@Input() sideNavItems: SideNavItemModel[] = [];
  @Input() showApplications: boolean;
  @Input() showNotifications = true;
  selectedRoute = '';

  menuOpened: boolean;
  temporaryMenuOpened = false;

  menuMode = 'shrink';
  menuRevealMode = 'expand';
  minMenuSize = 0;
  shaderEnabled = false;
	user: HhsgSharedUserProfile = <HhsgSharedUserProfile>{};
	private _unsubscribe$ = new Subject<void>();
  private _userServiceSubscription: Subscription;
  private loadingSubscription: Subscription;

  isLoading: boolean;

  constructor(private screen: ScreenService,
    private router: Router,
    public configService: HhsgSharedConfigService,
    public oidcSecurityService: OidcSecurityService,
    protected _userService: HhsgSharedUserService,
    private _loadingService: HhsgSharedLoadingService) { }

  ngOnDestroy(): void {
    this._userServiceSubscription?.unsubscribe();
    this.loadingSubscription?.unsubscribe();

    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  ngOnInit() {
    this.menuOpened = !this.screen.isCompact();

    this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {

      }
    });

    this.screen.changed.subscribe(() => this.updateDrawer());

    this.updateDrawer();

    // ----------- Above is original from devexpress
    this._userServiceSubscription = this._userService
			.getUserProfile()
			.pipe(takeUntil(this._unsubscribe$))
			.subscribe((user: HhsgSharedUserProfile) => {
				this.user = user;
    });

    this.loadingSubscription = this._loadingService.isLoading$.subscribe({
      next: (value) => this.isLoading = value,
      error: (error) => console.log(error.toString()),
      complete: () => this.isLoading = false
    });
  }

  setSelectedNavMenu(val: NavigationEnd) {
    // TODO: Does this work on a URL with parameters? (i.e. user admin)
    let url = val.urlAfterRedirects.split('?')[0];
    let navItem = this.findItemByRouteUrl(this.sideNavItems, url);

    this.selectedRoute = navItem.name;
  }

  // Define the recursive search function
  findItemByRouteUrl(items: SideNavItemModel[], routeUrl: string): SideNavItemModel | null {
    for (const item of items) {
      if (item.routeUrl === routeUrl) {
        return item;
      }

      if (item.items) {
        const foundItem = this.findItemByRouteUrl(item.items, routeUrl);
        if (foundItem) {
          return foundItem;
        }
      }
    }

    return null;
  }

  updateDrawer() {
    const isCompact = this.screen.isCompact();

    this.menuMode = !isCompact ? 'shrink' : 'overlap';
    this.menuRevealMode = isCompact ? 'slide' : 'expand';
    this.minMenuSize = isCompact ? 0 : 60;
    this.shaderEnabled = isCompact;
  }

  get hideMenuAfterNavigation() {
    return this.menuMode === 'overlap' || this.temporaryMenuOpened;
  }

  get showMenuAfterClick() {
    return !this.menuOpened;
  }

  navigationChanged(event) {
    const path = event.itemData.routeUrl;
    const pointerEvent = event.event;

    if (path && this.menuOpened) {
      this.router.navigate([path]);

      if (this.hideMenuAfterNavigation) {
        this.temporaryMenuOpened = false;
        this.menuOpened = false;
        pointerEvent.stopPropagation();
      }
    }
    else {
      this.menuOpened = true;
      pointerEvent.preventDefault();
    }
  }

  toggleMenu() {
    this.menuOpened = !this.menuOpened;
  }

  public closeMenu(): void {
    this.menuOpened = false;
  }

}
